module.exports = __webpack_public_path__ + "img/icon-mobility.86411837.svg";